import React from 'react';
import { useFormContext } from 'react-hook-form';
import NewPassword from 'common-mui/components/NewPassword';

const InputNewPassword = () => <NewPassword form={useFormContext()} />;

export default InputNewPassword;
